export async function apiErrorFromResponse(response, i18n) {
  let message;
  let params = {};
  try {
    const contentType = response.headers?.get('content-type') || '';
    const data = contentType.includes('json') ? await response.json() :
      contentType.includes('text/plain') ? await response.text() : null;
    if (typeof data === 'string') message = data;
    else if (data && typeof data === 'object') {
      message = data.message || data.key;
      params = data.params || {};
      if (!message && data.errors && typeof data.errors === 'object') {
        const firstError = Object.values(data.errors).flat().find(item => typeof item === 'string' && item.trim());
        message = firstError;
      }
      if (!message) message = data.detail;
    }
    if (typeof message === 'string' && message.trim().startsWith('{')) {
      const nested = JSON.parse(message);
      message = nested.key;
      params = nested.params || {};
    }
  } catch { message = null; /* Invalid or non-JSON error bodies use the status fallback. */ }

  const isKey = typeof message === 'string' && /^(api\.|errors\.)/.test(message);
  const responseKey = isKey && i18n.exists(message) ? message : null;
  const statusKey = `api.status.${response.status}`;
  const key = responseKey || (i18n.exists(statusKey) ? statusKey : 'api.status.generic');
  const error = new Error(i18n.t(key, responseKey ? params : {}));
  error.status = response.status;
  error.translationKey = key;
  error.translationParams = responseKey ? params : {};
  return error;
}
